module.exports = __webpack_public_path__ + "media/images/application/template/logos/thomas-cook-30c88c46b37b4fef2747cfa21550fc81.png";